import { LatLong } from 'types/asset';

export function formatCoordinates(coordinates: LatLong): string {
  return coordinates.map((coordinate) => coordinate.toFixed(5)).join(', ');
}
